import { Palette, Sprout, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Section, SectionTitle, Reveal } from "@/components/Section";
import { useContent } from "@/i18n";
import { Shape3D, HandNote } from "@/components/Objects3D";

const icons = { Palette, Sprout };

export const Interests = () => {
  const { c, ui } = useContent();
  return (
    <Section id="interests" num="08" chapter={ui.interests.chapter}>
      <Shape3D shape="camera" blue size={58} className="absolute right-[5%] top-16 hidden md:block" mouse />
      <div className="flex flex-wrap items-end justify-between gap-6">
        <SectionTitle className="max-w-2xl">
          {ui.interests.titleA} <span className="italic text-cobalt">{ui.interests.titleB}</span>
        </SectionTitle>
        <Reveal delay={0.15}>
          <HandNote className="rotate-[-3deg]">{ui.interests.note}</HandNote>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-6">
        {c.interests.map((interest, i) => {
          const Icon = interest.icon ? icons[interest.icon] : null;
          const rotations = ["-rotate-2", "rotate-1", "rotate-2", "-rotate-1", "rotate-1", "-rotate-2", "rotate-2"];
          return (
            <Reveal key={interest.title} delay={0.05 * i}>
              <Link
                to={`/beyond/${interest.slug}`}
                className={`tilt-hover group relative block h-full bg-white border border-line rounded-xl overflow-hidden shadow-[0_16px_36px_-24px_rgba(51,38,25,0.3)] ${rotations[i % rotations.length]}`}
                data-testid={`interest-card-${i}`}
              >
                {interest.image ? (
                  <div className="aspect-square overflow-hidden m-3 mb-0 rounded-lg">
                    <img
                      src={interest.image}
                      alt={interest.title}
                      className="frame-zoom w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                ) : (
                  <div className="aspect-square flex items-center justify-center m-3 mb-0 rounded-lg bg-powder/60">
                    {Icon && <Icon size={44} strokeWidth={1} className="text-cobalt" />}
                  </div>
                )}
                <div className="p-5 pt-4">
                  <h3 className="font-serif text-lg md:text-xl tracking-tight group-hover:text-cobalt transition-colors duration-400">
                    {interest.title}
                  </h3>
                  <p className="mt-1.5 text-xs md:text-sm leading-relaxed text-cocoa">{interest.text}</p>
                  <span className="mt-3 inline-flex items-center gap-1.5 text-[10px] tracking-[0.2em] uppercase font-bold text-cobalt opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    {ui.interests.open} <ArrowUpRight size={11} />
                  </span>
                </div>
              </Link>
            </Reveal>
          );
        })}
      </div>
    </Section>
  );
};
